import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { GiPadlock } from 'react-icons/gi';

const WHATSAPP_URL = 'https://wa.me/5508002802133?text=Ol%C3%A1%2C%20tenho%20uma%20d%C3%BAvida%20sobre%20meu%20pagamento.';

export default function VindiSupportBubble() {
  return (
    <Box position="fixed" bottom="20" right="4" zIndex={1000}>
      <Box
        as="a"
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        bg="white"
        borderRadius="xl"
        boxShadow="md"
        border="1px solid #E0E0E0"
        px={3}
        py={2}
        maxW="160px"
        display="block"
        cursor="pointer"
        _hover={{ boxShadow: 'lg', borderColor: '#5AB2AE' }}
        transition="all 0.2s"
      >
        <VStack spacing={0} align="flex-start">
          <Box display="flex" alignItems="center" gap={1}>
            <GiPadlock size={11} color="#5AB2AE" />
            <Text fontSize="9px" color="#9E9E9E" fontWeight="medium" letterSpacing="wide" textTransform="uppercase">
              Pagamento seguro
            </Text>
          </Box>
          <Text fontSize="11px" color="#424242" fontWeight="bold" lineHeight="1.3">
            Intermediado por{' '}
            <Text as="span" color="#5AB2AE">
              VINDI PAGAMENTOS S/A
            </Text>
          </Text>
          <Text fontSize="9px" color="#9E9E9E" lineHeight="1.3">
            Dúvidas? Clique aqui e fale com o suporte
          </Text>
        </VStack>
      </Box>
    </Box>
  );
}
